import { MenuItem } from "@mui/material";

const budgetValues = [
  2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 8000, 10000, 12000,
  15000, 20000, 30000, 40000, 50000,
];

export const generateBudgetOptions = () => {
  const options: JSX.Element[] = [];

  budgetValues.forEach((value) => {
    options.push(
      <MenuItem key={value} value={value.toString()}>
        {value.toLocaleString()}
      </MenuItem>
    );
  });
  return options;
};
